import { getStaffScopedApiPrefixOrCareAdvisor } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import {
  CareCoordinationReport,
  CreateCareCoordinationReportBenefitsNavigationParams,
  CreateCareCoordinationReportInternalNoteParams,
  CreateCareCoordinationReportNotesParams,
  ObjectType,
} from './types/types';

export const updateCareCoordinationObject = async (
  care_coordination_report_id: string,
  object_type: ObjectType,
  object_id: string,
  payload:
    | CreateCareCoordinationReportInternalNoteParams
    | CreateCareCoordinationReportBenefitsNavigationParams
    | CreateCareCoordinationReportNotesParams,
  userRole?: string,
): Promise<CareCoordinationReport> => {
  const prefix = getStaffScopedApiPrefixOrCareAdvisor(userRole);
  const { data } = await client.put<CareCoordinationReport>(
    `${prefix}/care_coordination_reports/${care_coordination_report_id}/${object_type}/${object_id}`,
    payload,
  );

  return data;
};
